import React from 'react';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import branding from '../branding';

/**
 * Minimal white-label footer: product name + support contact.
 * No marketing or pricing links — this is an internal advisor portal.
 */
const Footer = () => (
  <Box
    component="footer"
    sx={{
      mt: 'auto',
      py: 3,
      px: 2,
      background: '#1F2937',
      borderTop: '1px solid rgba(255,255,255,0.1)',
      position: 'relative',
      zIndex: 3,
    }}
  >
    <Container
      maxWidth="xl"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: 1,
        columnGap: 3,
        justifyContent: { xs: 'center', md: 'space-between' },
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" sx={{ color: '#D1D5DB', fontWeight: 600 }}>
        {branding.productName}
      </Typography>
      <MuiLink
        href={`mailto:${branding.supportEmail}`}
        sx={{
          color: '#9CA3AF',
          fontSize: '0.85rem',
          textDecoration: 'none',
          '&:hover': { color: '#FFFFFF' },
        }}
      >
        {branding.supportEmail}
      </MuiLink>
      <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '0.78rem' }}>
        © {new Date().getFullYear()} {branding.companyName}
      </Typography>
    </Container>
  </Box>
);

export default Footer;
